import React, { PropsWithChildren, RefObject } from 'react'
import { useTranslation } from 'react-i18next'

import { IconButton } from '@ui/components/Button'
import { Tooltip } from '@ui/components/Tooltip/Tooltip'
import { ArrowIcon } from '@ui/icons/Arrow.icon'

import { useWindowResize } from '@utils/domUtils'

import { FullScreenLayout } from '@shared/templates/FullScreenLayout'

interface PasswordVerificationTemplateProps extends PropsWithChildren {
  onBack?: () => void
  onExit?: () => void
  maxWidth?: number
  isLoading?: boolean
  contentRef?: RefObject<HTMLDivElement | null>
  header?: React.ReactNode
}

export const PasswordVerificationTemplate: React.FC<PasswordVerificationTemplateProps> = (
  props
) => {
  const { isLoading, onBack, children, maxWidth, contentRef, header } = props

  const { t } = useTranslation()
  const isMobile = useWindowResize()

  return (
    <FullScreenLayout
      maxContentWidth={maxWidth}
      contentRef={contentRef}
      isLoading={isLoading}
      header={header}
      headerLeftSlot={
        onBack ? (
          <Tooltip
            content={t('Trading Account.Go Back')}
            direction='top'
            pointer
            disabled={isMobile}
          >
            <IconButton.Secondary size='sm' icon={ArrowIcon.Left} onClick={onBack} />
          </Tooltip>
        ) : undefined
      }
    >
      {children}
    </FullScreenLayout>
  )
}
